"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderPopup = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const popover_1 = require("@base-ui-components/react/popover");
const context_1 = require("../../context");
const react_1 = require("react");
const app_1 = require("app");
const useScrollLock_1 = require("src/hooks/useScrollLock");
const Content = ({ children, popupClassName, side, anchor, positionerClassName, initialFocus = true, sideOffset = 0, }) => {
    const { headerElement } = (0, react_1.useContext)(context_1.HeaderContext);
    return ((0, jsx_runtime_1.jsxs)(popover_1.Popover.Portal, { container: headerElement, children: [(0, jsx_runtime_1.jsx)(popover_1.Popover.Backdrop, { id: "BACKDROP", className: "fixed w-screen h-screen top-(--header-height) bg-overlay-primary" }), (0, jsx_runtime_1.jsx)(popover_1.Popover.Positioner, { id: "POSITIONER", side: side, anchor: anchor, collisionPadding: 0, collisionAvoidance: { side: 'none', align: 'none' }, sideOffset: sideOffset, positionMethod: "fixed", className: (0, app_1.cn)('max-md:!transform-none max-md:!inset-0 max-md:!top-(--header-height)', positionerClassName), children: (0, jsx_runtime_1.jsx)(popover_1.Popover.Popup, { initialFocus: initialFocus, id: "POPUP", className: (0, app_1.cn)('max-md:h-full max-md:py-md max-md:px-sm max-md:border-t bg-surface-primary border-secondary flex flex-col', popupClassName), children: children }) })] }));
};
const HeaderPopup = (_a) => {
    var _b;
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    (0, useScrollLock_1.useScrollLock)((_b = props === null || props === void 0 ? void 0 : props.open) !== null && _b !== void 0 ? _b : false);
    return (0, jsx_runtime_1.jsx)(popover_1.Popover.Root, Object.assign({}, props, { children: children }));
};
exports.HeaderPopup = HeaderPopup;
const Trigger = (props) => {
    return (0, jsx_runtime_1.jsx)(popover_1.Popover.Trigger, Object.assign({}, props));
};
exports.HeaderPopup.Trigger = Trigger;
exports.HeaderPopup.Content = Content;
